// src/pages/Home/Home.js
import React,{useEffect,useState} from "react";
import "../../styles/components/pages/Home.css";
import HomeText from "./HomeText";
// import SocialLink from "./SocialLink";
import ButtonContact from "./ButtonContact";
import AboutBottun from "./AboutBottun.jsx";
import MyProjectsButton from "./MyProjectsButton";
import ServicesButton from "./ServicesBottun";
import BlogButton from "./BlogButton";
// import Amazon from "../../components/Amazon/Amazon";
import   Project  from '../../components/ProjectCard/Projects'
import Services from "../Services/Services";
import Aboute from "../AboutMe/Aboute"


const Home = () => {
  // const videoRef = useRef(null);

  // const handleVideoEnd = () => {
  //   // Restart the video when it ends
  //   videoRef.current.currentTime = 0;
  //   videoRef.current.play();
  // };

  const [isContactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setContactOpen(true);
    }, 500); // Adjust the timeout duration as needed

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    
    <div className="home">
      <div className="home-container">
        <div className="item item-1">
        <div className={`container-1 ${isContactOpen ? 'contact open' : 'contact'}`}>
    <div className="text">
      <HomeText />
    </div>
    <div className="button-home">
      <div className="contact">
        <ButtonContact />
      </div>
      <div className="about">
        <AboutBottun />
      </div>
    </div>
  </div>
  <div className="picture-container">
        <div className="profile-picture">
          {/* Wrap the <video> tag in an <a> tag */}
          {/* <a href="https://codered.harutdev.com/"> */}
       <img src="/img/FreelanceDeveloper.webp" alt="" />
          {/* </a> */}
        </div>
      </div>

        </div>
        <div className="item item-2">
        <div className="button-1">
  <MyProjectsButton />
</div>
          <div className="button-2"><ServicesButton /></div>
          <div className="button-3"><BlogButton /></div>
        
         <div className="social-link-container">
            <div className="cv-item" >
              <a target="_blank" href="resume.pdf" className="download-button" alt="resume.pdf ">
                <svg xmlns="http://www.w3.org/2000/svg" width="69" height="30" viewBox="0 0 69 30" fill="none">
                  <path d="M16.8858 30C11.1037 30 6.84388 28.7318 4.10633 26.1955C1.36878 23.6592 0 20.0396 0 15.3369C0 10.6077 1.36878 6.86922 4.10633 4.12153C6.84388 1.37384 11.1037 0 16.8858 0C24.9706 0 30.3817 2.86658 33.1193 8.59974C30.8166 9.41876 28.1175 10.6473 25.0217 12.2853C24.2798 10.8058 23.1029 9.70938 21.4911 8.99604C19.9048 8.28269 18.2802 7.92602 16.6172 7.92602C14.1611 7.92602 12.3318 8.59974 11.1293 9.94716C9.92682 11.2682 9.32558 12.9062 9.32558 14.8613C9.32558 16.9749 9.9652 18.7054 11.2444 20.0528C12.5492 21.3738 14.532 22.0343 17.1928 22.0343C19.3164 22.0343 21.0049 21.6777 22.2586 20.9643C23.5122 20.2246 24.4333 19.0621 25.0217 17.4769C27.1197 18.6394 29.806 19.9472 33.0809 21.4003C31.8016 24.5971 29.6653 26.8296 26.6719 28.0978C23.6785 29.3659 20.4165 30 16.8858 30Z" fill="#F1F1F1" />
                  <path d="M68.8235 0.832234L66.2907 6.89564C64.0648 12.2589 62.3123 16.5522 61.033 19.7754C59.7538 22.9987 58.5769 26.2748 57.5024 29.6037H46.0277C44.9787 26.3276 43.8146 23.0911 42.5354 19.8943C41.2817 16.6711 39.5931 12.5495 37.4696 7.52972C37.1114 6.68428 36.1776 4.45178 34.6681 0.832234H45.3369C46.1044 3.39498 47.2429 6.68428 48.7524 10.7001C50.0828 14.2404 51.1574 17.3052 51.9761 19.8943C52.5134 18.0713 53.153 16.1295 53.8949 14.0687C54.6625 11.9815 55.123 10.7133 55.2765 10.2642C56.7604 6.22193 57.8477 3.07794 58.5385 0.832234H68.8235Z" fill="#F1F1F1" />
                </svg>
              </a>
            </div>
          
            <div className="git">
              <a
                target="_blank"
                rel="noreferrer"
                className="git-1"
                href="https://github.com/HarutAzatyan777"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="54" viewBox="0 0 45 54" fill="none">
                  <path d="M0.154111 33.2968C-0.0513702 33.0912 -0.0513702 32.8857 0.154111 32.6802C0.564994 32.2691 1.07878 32.115 1.69514 32.2177C2.31158 32.3205 2.67117 32.4233 2.77391 32.526C3.4931 32.8343 4.28937 33.528 5.16259 34.6071C6.0358 35.6862 6.72934 36.4312 7.24312 36.8422C9.70889 38.8976 12.226 39.0517 14.7945 37.3047C14.9999 36.5853 15.3339 35.9687 15.7961 35.4548C16.2584 34.941 16.6952 34.5814 17.1061 34.3758C17.5172 34.1702 18.2363 33.8619 19.2638 33.4509C15.8732 33.1426 13.125 32.5516 11.0188 31.6781C8.91261 30.8046 7.24305 29.6998 6.01016 28.3639C4.36631 26.5141 3.36455 24.099 3.00496 21.1188C2.64529 18.1385 2.8765 15.4152 3.6985 12.9488C4.31494 11.4073 5.18824 10.02 6.3183 8.78669C5.49638 6.2175 5.65049 3.28863 6.78063 7.84949e-05C10.0683 0.205613 13.0478 1.33605 15.7191 3.3914C20.8561 2.05543 26.1986 2.00404 31.7465 3.23725C32.4657 2.72341 33.5702 2.08116 35.0598 1.31032C36.5496 0.539567 38.4246 0.102767 40.6849 0C41.0959 1.13044 41.3784 2.46642 41.5326 4.00793C41.6867 5.54944 41.6096 6.98818 41.3014 8.32415C43.6644 10.7906 44.8973 14.0791 45 18.1898C45 21.4784 44.435 24.2017 43.3049 26.3598C42.1747 28.5179 40.1713 30.3164 37.2945 31.755C35.3425 32.68 32.774 33.2452 29.589 33.4507C31.0275 34.1701 32.0805 34.9152 32.7483 35.6859C33.4162 36.4567 33.8528 37.6642 34.0584 39.3084V44.1643L34.2124 48.8659C34.5206 49.3798 34.8803 49.8165 35.2913 50.1763C35.7022 50.536 36.0618 50.7929 36.37 50.947C36.6782 51.1012 36.781 51.3324 36.6782 51.6407C36.5754 51.949 36.1645 52.1032 35.4454 52.1032C33.6987 52.1032 32.3118 51.4866 31.2844 50.2533C30.9762 49.7395 30.8221 49.123 30.8221 48.4035V41.0043C30.8221 40.1821 30.6166 39.5912 30.2056 39.2315C29.7947 38.8717 29.3837 38.6405 28.9727 38.5378V48.2493C28.9727 49.9963 29.1782 51.1268 29.5892 51.6406C30.0001 52.1544 30.257 52.6683 30.3598 53.1821C30.4625 53.2849 30.3854 53.3619 30.1286 53.4133C29.8718 53.4646 29.4351 53.3876 28.8186 53.1821C27.483 52.8738 26.5583 52.1801 26.0446 51.101C25.5309 50.022 25.2741 48.8658 25.2741 47.6326V38.0755H23.2706V47.6328C23.2706 48.866 23.0137 50.0479 22.5 51.1783C21.7809 52.6171 20.4452 53.3878 18.4932 53.4906C18.185 53.3878 18.0309 53.285 18.0309 53.1823C18.1336 53.0795 18.4418 52.5657 18.9555 51.6408C19.0583 51.4353 19.1867 51.0242 19.3409 50.4076C19.495 49.791 19.5721 49.0716 19.5721 48.2495V38.5379C19.1611 38.6407 18.7758 38.8719 18.4162 39.2316C18.0566 39.5914 17.8768 40.1823 17.8768 41.0044V48.4037C17.8768 49.1229 17.7226 49.7396 17.4144 50.2535C16.4898 51.4867 15.1028 52.1034 13.2535 52.1034C12.5343 52.1034 12.1234 51.9492 12.0206 51.6409C11.9178 51.4354 11.9435 51.2555 12.0977 51.1013C12.2519 50.9472 12.483 50.7673 12.7913 50.5618C13.0995 50.3562 13.305 50.202 13.4077 50.0993C13.8187 49.791 14.1268 49.3799 14.3324 48.8661C14.6406 48.455 14.7176 47.376 14.5635 45.6289C14.4094 43.8819 14.3837 42.7515 14.4864 42.2376C11.8151 43.1625 9.09253 42.7 6.31846 40.8503C5.49654 40.0281 4.67461 38.8462 3.85269 37.3048C3.23624 36.1743 2.00336 34.8383 0.154111 33.2968Z" fill="#F1F1F1" />
                </svg>
              </a>
            </div>

        
          </div>
          <div className="social-link-container">
         
          <div className="mail">
  <a className="mail-1"  href="mailto:harutazatyan45@gmail.com?subject=Subject%20of%20the%20email&body=Body%20of%20the%20email">
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="37" viewBox="0 0 45 37" fill="none">
      <path d="M39.7373 0H5.26271C2.36441 0 0 2.36441 0 5.26271V31.0519C0 33.9502 2.36441 36.3146 5.26271 36.3146H39.7373C42.6356 36.3146 45 33.9502 45 31.0519V5.26271C45 2.36441 42.6356 0 39.7373 0ZM36.2383 5.13877L22.5191 14.9778L9.21928 5.13877H36.2383ZM39.7373 31.1759H5.26271C5.19597 31.1759 5.13877 31.1186 5.13877 31.0519V8.5233L22.4714 21.3369L39.8517 8.87606V31.0614C39.8517 31.1186 39.804 31.1759 39.7373 31.1759Z" fill="#F1F1F1" />
    </svg>
  </a>
</div>

         

            <div className="linkdin">
              <a
                target="_blank"
                rel="noreferrer"
                className="linkdin-1"
                href="https://www.linkedin.com/in/harut-azatyan/"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
                  <g clip-path="url(#clip0_158_812)">
                    <path d="M0 4.99517C0 3.54727 0.506771 2.35277 1.52027 1.41168C2.53377 0.470545 3.85137 0 5.47297 0C7.06565 0 8.35423 0.463292 9.3388 1.38996C10.3523 2.34556 10.8591 3.5907 10.8591 5.12548C10.8591 6.51544 10.3668 7.67372 9.38224 8.60039C8.36874 9.55598 7.03668 10.0338 5.3861 10.0338H5.34266C3.74999 10.0338 2.4614 9.55598 1.47683 8.60039C0.492264 7.64479 0 6.44304 0 4.99517ZM0.564672 43.0019V13.9865H10.2075V43.0019H0.564672ZM15.5502 43.0019H25.1931V26.8002C25.1931 25.7866 25.3089 25.0048 25.5405 24.4546C25.9459 23.4701 26.5613 22.6375 27.3866 21.957C28.2119 21.2765 29.2471 20.9363 30.4923 20.9363C33.7355 20.9363 35.3571 23.1226 35.3571 27.4952V43.0019H45V26.3658C45 22.0801 43.9865 18.8296 41.9595 16.6144C39.9324 14.3991 37.2539 13.2915 33.9237 13.2915C30.1882 13.2915 27.278 14.8986 25.1931 18.1129V18.1998H25.1496L25.1931 18.1129V13.9865H15.5502C15.6081 14.9131 15.6371 17.7944 15.6371 22.6303C15.6371 27.4662 15.6081 34.2567 15.5502 43.0019Z" fill="#F1F1F1" />
                  </g>
                  <defs>
                    <clipPath id="clip0_158_812">
                      <rect width="45" height="43.002" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>



        </div>
        <div>
        
        </div>
        
        <div><Aboute/></div>

       <div> <Project /></div>
       <div> <Services /></div>
       
        {/* <div><Products /></div> */}
        {/* <a href="https://codered.harutdev.com/">
            <video
              ref={videoRef}
              width="100%"
              height="100%"
              controls
              autoPlay
              muted
              style={{ borderRadius: '25px' }}
              onEnded={handleVideoEnd}
            >
              <source src="video/CodeRed.webm" type="video/webm" />
            </video>
          </a> */}
      </div>


    </div>
  );
};

export default Home;
